import React from 'react'
import { observer } from 'mobx-react-lite'
import useSettingsPage from './hooks/useSettingsPage'
import Main from './components/Main/Main'
import Profile from './components/Profile/Profile'
import Notifications from './components/Notifications/Notifications'
import Language from './components/Language/Language'
import Support from './components/Support/Support'
import SchoolScheduleOptions from './components/SchoolScheduleOptions/SchoolScheduleOptions'
import s from './styles/SettingsPage.module.scss'

const VIEW_COMPONENTS = {
	main: Main,
	profile: Profile,
	notifications: Notifications,
	language: Language,
	support: Support,
	'school-preferences': SchoolScheduleOptions,
}

export const SettingsPage = observer(() => {
	const vm = useSettingsPage()
	const View = VIEW_COMPONENTS[vm.view] || Main

	return (
		<div className={s.page}>
			<View {...vm} />
		</div>
	)
})

export default SettingsPage
